var r="4.21.3";export{r as version};
//# sourceMappingURL=package.json.js.map
